import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../services/api';

function SituacoesFormPage() {
  const [nome, setNome] = useState('');
  // CORREÇÃO: Inicia o tipo como vazio para forçar a seleção.
  const [tipo, setTipo] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const navigate = useNavigate();
  const { id } = useParams();

  const pageTitle = id ? 'Editar Situação' : 'Nova Situação';
  const pageSubtitle = id ? `Editando o registro #${id}` : 'Preencha os dados para criar uma nova situação';

  useEffect(() => {
    if (id) {
      setLoading(true);
      api.get(`/situacoes/${id}`)
        .then(response => {
          const { nome, tipo } = response.data.data;
          setNome(nome);
          setTipo(tipo);
        })
        .catch(err => {
          setError('Não foi possível carregar os dados da situação.');
          console.error(err);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [id]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError(null);

    const situacaoData = { nome, tipo };

    try {
      if (id) {
        await api.put(`/situacoes/${id}`, situacaoData);
      } else {
        await api.post('/situacoes', situacaoData);
      }
      navigate('/painel/situacoes');
    } catch (err) {
      // Captura de erro mais específica para o frontend
      if (err.response && err.response.data && err.response.data.message) {
        setError(err.response.data.message);
      } else {
        setError('Ocorreu um erro ao salvar a situação. Verifique os dados.');
      }
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading && id) {
    return <p>Carregando dados da situação...</p>;
  }

  return (
    <>
      <div className="content-header">
        <h1 className="content-title">{pageTitle}</h1>
        <p className="content-subtitle">{pageSubtitle}</p>
      </div>

      <div className="card">
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            {error && <div className="alert alert-danger">{error}</div>}

            <div className="mb-3">
              <label htmlFor="nome" className="form-label">Nome</label>
              <input
                type="text"
                className="form-control"
                id="nome"
                value={nome}
                onChange={(e) => setNome(e.target.value)}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="tipo" className="form-label">Tipo</label>
              <select
                className="form-select"
                id="tipo"
                value={tipo}
                onChange={(e) => setTipo(e.target.value)}
                required // O 'required' agora funcionará corretamente
              >
                {/* CORREÇÃO: Adicionada a opção padrão desabilitada */}
                <option value="" disabled>Selecione...</option>
                <option value="adolescente">Adolescente</option>
                <option value="movimentacao">Movimentação</option>
              </select>
            </div>

            <div className="d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-secondary me-2"
                onClick={() => navigate('/painel/situacoes')}
                disabled={loading}
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default SituacoesFormPage;